/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loginemailplaceholder2Inputs */

const en_loginemailplaceholder2 = /** @type {(inputs: Loginemailplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const pt_loginemailplaceholder2 = /** @type {(inputs: Loginemailplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voce@exemplo.com`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Loginemailplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const loginemailplaceholder2 = /** @type {((inputs?: Loginemailplaceholder2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loginemailplaceholder2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loginemailplaceholder2(inputs)
	return pt_loginemailplaceholder2(inputs)
});
export { loginemailplaceholder2 as "loginEmailPlaceholder" }